"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaddingBox = exports.StyledLabel = exports.TextArea = exports.InputInner = exports.Input = exports.InputWrap = exports.inputStyle = void 0;
const app_1 = require("@obvio/app");
const react_textarea_autosize_1 = __importDefault(require("react-textarea-autosize"));
exports.inputStyle = (0, app_1.css) `
  border: 0.0625rem solid ${(theme) => theme.stroke};
  border-radius: ${(theme) => theme.radius.small};
  padding: 0 ${(theme) => theme.spacing.small};
  ${app_1.styled.invalid `
    border-color: ${(theme) => theme.colors.error};
  `}
`;
exports.InputWrap = app_1.styled.div `
  position: relative;
  ${exports.inputStyle}
  ${(theme) => { var _a; return [theme.inputs.css, (_a = theme.inputs.text) === null || _a === void 0 ? void 0 : _a.css]; }}
  display: grid;
  grid-template-columns: ${(_, { $hasPrefix, $hasSuffix }) => `${$hasPrefix ? 'auto' : ''} 1fr ${$hasSuffix ? 'auto' : ''}`};
  align-items: center;
  &[aria-disabled],
  &[readonly] {
    background: ${(theme) => theme.colors.gray.alpha(0.1)};
  }
  ${(_, { $hasPrefix }) => $hasPrefix
    ? (0, app_1.css) `
          padding-left: 0;
        `
    : {}}
  ${(_, { $hasSuffix }) => $hasSuffix
    ? (0, app_1.css) `
          padding-right: 0;
        `
    : {}}
`;
exports.Input = app_1.styled.input `
  @media ${app_1.mobile} {
    font-size: 16px;
  }
  ${exports.inputStyle}
  height: 2.25em;
  background: white;
  width: 100%;
  ${(theme) => { var _a; return [theme.inputs.css, (_a = theme.inputs.text) === null || _a === void 0 ? void 0 : _a.css]; }}
  text-overflow: ellipsis;
`;
exports.InputInner = app_1.styled.input `
  @media ${app_1.mobile} {
    font-size: 16px;
  }
  ${exports.inputStyle}
  ${(theme) => [theme.inputs.css]}
  margin: 0;
  height: 100%;
  width: 100%;
  padding: 0;
  background-color: rgba(0, 0, 0, 0);
  border: none;
  height: 2.25rem;
  ${app_1.styled.focus `
    border: none;
    box-shadow: none;
  `}
`;
exports.TextArea = (0, app_1.styled)(react_textarea_autosize_1.default) `
  @media ${app_1.mobile} {
    font-size: 16px;
  }
  ${exports.inputStyle}
  resize: none;
  padding-top: 0.5625em;
  padding-bottom: 0.5625em;
  width: 100%;
  ${(theme) => { var _a; return [theme.inputs.css, (_a = theme.inputs.textarea) === null || _a === void 0 ? void 0 : _a.css]; }}
`;
exports.StyledLabel = app_1.styled.label `
  display: block;
  font-size: 0.875rem;
  margin-bottom: 0.625rem;
`;
exports.PaddingBox = app_1.styled.div `
  flex: 1;
`;
